import { ArrowDownward } from "@mui/icons-material";
import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "../../css/Header.css";
import logo from "../../images/logo.png";
const Header = () => {
    const [isMatched, setIsMatched] = useState(false);
    const [isPassed, setIsPassed] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/") {
            setIsMatched(false);
        } else {
            setIsMatched(true);
        }
    }, [location.pathname])

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 250;
            scrollCheck ? setIsPassed(true) : setIsPassed(false);
        })
    })


    return (
        <>
        <Navbar className={`${isPassed ? "navbar__active" : ""} ${isMatched ? "navbar__shadow": ""}  navbar`} expand="lg">
            <Container>
                <NavLink to="/"><img className="navbar__logo navbar__heading" src={logo} alt="logo" /> </NavLink>
                <Navbar.Toggle className="navbar__heading navbar__toggle" aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="navbar__ul ms-auto">
                        <NavLink className="navbar__li" to="/">Home</NavLink>
                        <NavLink className="navbar__li" to="/about">About </NavLink>
                        {/*<NavLink className="navbar__li" to="/services">Services </NavLink>*/}
                        <NavLink className="navbar__li" to="/Projects">My Projects </NavLink>
                        <NavLink className="navbar__li" to="/contact">Contact Me </NavLink>
                        <a className="navbar__btn" href="https://drive.google.com/file/d/1PwV7raDyzu1nW_LV10C1On01IG91olEj/view" target="_blank" rel="noreferrer"><ArrowDownward />  Resume </a>
                        </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        <Outlet />
        </>
    )
}

export default Header;